// App.jsx — Full fix
import { useContext, useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Context } from "./context/Context";

// ✅ Only eagerly load what's visible on first paint
import Home from "./component/home/Main";
import Navbar from "./component/Navbar/Navs";
import Footer from "./component/Footer/Foot";
import Scroll from "./component/scroll/Scrolltop";
import Social from "./component/scroll/social";

// Third-party JS only (CSS loaded individually by each component)
// import "bootstrap/dist/css/bootstrap.min.css";
// Third-party JS only (CSS loaded individually by each component)
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import CorporateProfile from "./component/corporateprofile/CorporateProfile";
import ShareholdingPattern from "./component/shareholdingpattern/ShareholdingPattern";
import StockExchangeInfo from "./component/stockexchangeinfo/StockExchangeInfo";
import InvestorAnalysMeetings from "./component/investoranalystmeetings/InvestorAnalysMeetings";
import MaterialDocuments from "./component/materialdocuments/MaterialDocuments";
import AnnouncementDisclosure from "./component/announcementdisclosure/AnnouncementDisclosure";
import BoardOfDirector from "./component/boardofdirector/BoardOfDirector";

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import "react-tabs/style/react-tabs.css";
// import "react-toastify/dist/ReactToastify.css";

// import "aos/dist/aos.css";
// import "swiper/css";
// import "swiper/css/autoplay";

// // Base CSS
// import "./App.css";
// import "./index.css";

// // Layout / common CSS
// import "./component/Navbar/nav.css";
// import "./component/Footer/foot.css";
// import "./component/scroll/scroll.css";

// // Home CSS
// import "./component/home/main.css";
// import "./component/home/responsive.css";
// import "./component/home/timline.css";
// import "./component/home/App.css";

// // About CSS
// import "./component/about/about.css";
// import "./component/about/abouresponsive.css";
// import "./component/about/awards.css";

// // Business Area / Substation CSS
// import "./component/Substation/substation.css";
// import "./component/Substation/subresponsive.css";

// // Project / Ongoing / Completed CSS
// import "./component/projects/projects.css";
// import "./component/ongoing/ongoing.css";

// // Career shared hero CSS
// import "./component/career/career.css";

// // Blogs / Media CSS
// import "./component/blogs/blog.css";
// import "./component/blogs/blogresponsive.css";
// import "./component/media/media.css";

// // Other page CSS
// import "./component/contacts/contact.css";
// import "./component/financials/financials.css";
// import "./component/disclosure/disclosure.css";
// import "./component/notices/notices.css";
// import "./component/policies/policies.css";
// import "./component/Sustainability/sustainability.css";
// import "./component/portfolio/Timeline.css";
// import "./component/portfolio/benchmark.css";
// import "./component/portfolio/portfolio.css";
// import "./component/helpdesk/helpdesk.css";

// // Auth / admin CSS
// import "./pages/login/login.css";
// import "./pages/register/register.css";
// import "./pages/settings/settings.css";
// import "./pages/write/write.css";
// import "./admin/components/admin.css";

// ✅ Lazy load everything else
const About = lazy(() => import("./component/about/About"));
const Sprojects = lazy(() => import("./component/Substation/Sprojects"));
const OngoingP = lazy(() => import("./component/ongoing/Cement"));
const OngoingC = lazy(() => import("./component/ongoing/Psu"));
const OngoingSo = lazy(() => import("./component/ongoing/Solar"));
const OngoingSu = lazy(() => import("./component/ongoing/Sugar"));
const OngoingOver = lazy(() => import("./component/ongoing/Oversease"));
const CompletedProject1 = lazy(() => import("./component/completed/Bsnl"));
const CompletedProject2 = lazy(() => import("./component/completed/Ccement"));
const CompletedProject3 = lazy(
  () => import("./component/completed/CementPlants"),
);
const CompletedProject4 = lazy(() => import("./component/completed/Esic"));
const CompletedProject5 = lazy(() => import("./component/completed/Indian"));
const CompletedProject6 = lazy(() => import("./component/completed/Msd"));
const CompletedProject7 = lazy(() => import("./component/completed/Mse"));
const CompletedProject8 = lazy(() => import("./component/completed/Overses"));
const CompletedProject9 = lazy(() => import("./component/completed/CSolar"));
const CompletedProject10 = lazy(() => import("./component/completed/CSugar"));
const CompletedProject11 = lazy(
  () => import("./component/completed/SugarCogent"),
);
const Cogen = lazy(() => import("./component/Substation/Cogen"));
const Newsubstation = lazy(
  () => import("./component/Substation/NewSubstation"),
);
const Electricle = lazy(() => import("./component/Substation/Electricle"));
const Epcontacts = lazy(() => import("./component/Substation/EpcContacts"));
const Ssolar = lazy(() => import("./component/Substation/Ssolar"));
const Scement = lazy(() => import("./component/Substation/Scement"));
const Transmisionline = lazy(
  () => import("./component/Substation/Transmisionline"),
);
const Policies = lazy(() => import("./component/policies/Policies"));
const Notices = lazy(() => import("./component/notices/Notices"));
const CsrActivity = lazy(
  () => import("./component/Sustainability/Csractivity"),
);
const Environment = lazy(
  () => import("./component/Sustainability/Environment"),
);
const GreenBuilding = lazy(
  () => import("./component/Sustainability/GreenBuilding"),
);
const Projects = lazy(() => import("./component/projects/Projects"));
const Portfolio = lazy(() => import("./component/portfolio/NewTimeline"));
const Projects1 = lazy(() => import("./component/projects/Projects1"));
const Projects2 = lazy(() => import("./component/projects/OtherCorporate"));
const Projects3 = lazy(() => import("./component/projects/Overseas"));
const Projects4 = lazy(() => import("./component/projects/Power"));
const Projects6 = lazy(() => import("./component/projects/Generation"));
const OngoingProject = lazy(
  () => import("./component/projects/OngoingProject"),
);
const Completedprojects = lazy(
  () => import("./component/projects/Completedprojects"),
);
const Blogs = lazy(() => import("./component/blogs/Blogs"));
const BlogDetails = lazy(() => import("./component/blogs/BlogDetails"));
const Transmition = lazy(() => import("./component/blogs/Transmition"));
const TransmitionStatus = lazy(
  () => import("./component/blogs/TransmitionStatus"),
);
const Media = lazy(() => import("./component/media/Media"));
const Financials = lazy(() => import("./component/financials/Financials"));
const Career = lazy(() => import("./component/career/Career"));
const CarrierDetailsForm = lazy(
  () => import("./component/career/CarrierDetailsForm"),
);
const Contacts = lazy(() => import("./component/contacts/Contacts"));
const Login = lazy(() => import("./pages/login/Login"));
const Register = lazy(() => import("./pages/register/Register"));
const Settings = lazy(() => import("./pages/settings/Settings"));
const AdminRoutes = lazy(() => import("./AdminRoutes"));
const Board = lazy(() => import("./component/board-committee/Board"));
const DisclosureLodr = lazy(
  () => import("./component/disclosure/DisclosureLodr"),
);
const HelpDesk = lazy(() => import("./component/helpdesk/HelpDesk"));
const IpoDocuments = lazy(
  () => import("./component/ipodocuments/IpoDocuments"),
);
// ✅ Simple loading fallback
const PageLoader = () => <div style={{ minHeight: "100dvh" }} />;

function App() {
  const { user } = useContext(Context);
  const [notification, setNotification] = useState("");

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(""), 3000);
  };

  // const isAdmin = () => user && user.role === "admin";

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);
    return () => document.removeEventListener("contextmenu", disableRightClick);
  }, []);

  return (
    <Router>
      <Navbar />
      {notification && <div className="notification">{notification}</div>}
      {/* ✅ Wrap ALL routes in Suspense */}
      <main style={{ minHeight: "100dvh" }}>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/Substation" element={<Sprojects />} />
            <Route path="/Cement" element={<OngoingP />} />
            <Route path="/Psu" element={<OngoingC />} />
            <Route path="/Solar" element={<OngoingSo />} />
            <Route path="/Sugar" element={<OngoingSu />} />
            <Route path="/Oversease" element={<OngoingOver />} />
            <Route path="/Bsnl" element={<CompletedProject1 />} />
            <Route path="/Ccement" element={<CompletedProject2 />} />
            <Route path="/CementPlants" element={<CompletedProject3 />} />
            <Route path="/Esic" element={<CompletedProject4 />} />
            <Route path="/Indian" element={<CompletedProject5 />} />
            <Route path="/Msd" element={<CompletedProject6 />} />
            <Route path="/Mse" element={<CompletedProject7 />} />
            <Route path="/Overses" element={<CompletedProject8 />} />
            <Route path="/CSolar" element={<CompletedProject9 />} />
            <Route path="/CSugar" element={<CompletedProject10 />} />
            <Route path="/SugarCogent" element={<CompletedProject11 />} />
            <Route path="/Cogen" element={<Cogen />} />
            <Route path="/Newsubstation" element={<Newsubstation />} />
            <Route path="/Electricle" element={<Electricle />} />
            <Route path="/EpcContacts" element={<Epcontacts />} />
            <Route path="/Ssolar" element={<Ssolar />} />
            <Route path="/Scement" element={<Scement />} />
            <Route path="/Transmisionline" element={<Transmisionline />} />
            <Route path="/Policies" element={<Policies />} />
            <Route path="/board-committee" element={<Board />} />
            <Route path="/Notices" element={<Notices />} />
            <Route path="/Csractivity" element={<CsrActivity />} />
            <Route path="/Environment" element={<Environment />} />
            <Route path="/GreenBuilding" element={<GreenBuilding />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/Projects1" element={<Projects1 />} />
            <Route path="/OtherCorporate" element={<Projects2 />} />
            <Route path="/Overseas" element={<Projects3 />} />
            <Route path="/Power" element={<Projects4 />} />
            <Route path="/Generation" element={<Projects6 />} />
            <Route path="/OngoingProject" element={<OngoingProject />} />
            <Route path="/Completedprojects" element={<Completedprojects />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/TransmitionStatus" element={<TransmitionStatus />} />
            <Route path="/Transmition" element={<Transmition />} />
            <Route path="/BlogDetails/:blogId" element={<BlogDetails />} />
            <Route path="/media" element={<Media />} />
            <Route path="/financials" element={<Financials />} />
            <Route path="/career" element={<Career />} />
            <Route path="/corporate-profile" element={<CorporateProfile />} />
            <Route
              path="/shareholding-pattern"
              element={<ShareholdingPattern />}
            />
            <Route
              path="/stock-exchange-info"
              element={<StockExchangeInfo />}
            />
            <Route
              path="/investor-analyst-meetings"
              element={<InvestorAnalysMeetings />}
            />
            <Route path="/material-documents" element={<MaterialDocuments />} />
            <Route path="/corporate-profile" element={<CorporateProfile />} />
            <Route
              path="/announcements-disclosure"
              element={<AnnouncementDisclosure />}
            />
            <Route path="/disclosure" element={<DisclosureLodr />} />
            <Route path="/helpdesk" element={<HelpDesk />} />
            <Route path="/ipo-documents" element={<IpoDocuments />} />
            <Route path="/board-of-directors" element={<BoardOfDirector />} />
            <Route
              path="/CarrierDetailsForm/:jobId"
              element={<CarrierDetailsForm />}
            />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/Login" element={user ? <Home /> : <Login />} />
            <Route
              path="/Settings"
              element={user ? <Settings /> : <Register />}
            />
            <Route
              path="/*"
              element={<AdminRoutes showNotification={showNotification} />}
            />
          </Routes>
        </Suspense>
      </main>
      <Social />
      <Scroll />
      <Footer />
    </Router>
  );
}

export default App;
